/**
 * Tailwind skeleton "bone" — a pulsing placeholder block.
 * Use with arbitrary widths/heights via className.
 *
 * @example <Bone className="h-4 w-32" />
 * @example <Bone className="h-48 w-full rounded-xl" />
 */
const Bone = ({ className = '' }: { className?: string }) => (
  <div className={`animate-pulse rounded bg-cream-300 ${className}`} />
)

export default Bone
